/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateFolderDto interface.
 */
export function instanceOfCreateFolderDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    return true;
}
export function CreateFolderDtoFromJSON(json) {
    return CreateFolderDtoFromJSONTyped(json, false);
}
export function CreateFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'parentId': json['parentId'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}
export function CreateFolderDtoToJSON(json) {
    return CreateFolderDtoToJSONTyped(json, false);
}
export function CreateFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'parentId': value['parentId'],
        'tags': value['tags'],
    };
}
